import { useState, useEffect } from "react";
import styled from "styled-components";

const StyledSelect = styled.select`
  display: block;
  position: absolute;
  max-width: 100px;
  border: 1px solid;
  border-radius: 5px;
  padding: 2px;
  font-size: 0.8em;
  color: white;
  background: deeppink;
`;

const StyledMorpheme = styled.div`
  display: inline-block;
  /* margin-left: 5px; */
  /* &:hover {
    background-color: grey;
    ${StyledSelect} {
      display: block;
    }
  } */
`;

function ExcelMorpheme({
  children,
  changeMorpheme,
  spellIndex,
  spellEle,
  rowIdx,
  morpheme,
  constituentColor
}) {
  const [selecting, setSelecting] = useState(false)
  // const colorList = {
  //   0:["white", "미정"],
  //   sentence_subject:["#F8B1B1", "주어"],
  //   sentence_verb:["#D6F7C6", "동사"],
  //   sentence_complement:["#EACA2C", "보어"],
  //   sentence_direct_object:["#C6D8FC", "직목"],
  //   sentence_indirect_object:["#E1EAFA", "간목"],
  //   sentence_adverb:["white", "부사"],
  //   sentence_etc:["#C300FA", "기타"],
  // };
  // console.log('마지막이길',morpheme)
  // const [color, setColor] = useState(colorList[morpheme || 0][0]);

  let color = constituentColor[morpheme] ? constituentColor[morpheme][0] : "#FFFFFF"

  // console.log('마지막이길2',morpheme)
  // console.log(color)

  const morphemeHandler = (e) => {
    // console.log(color,'다뀌기 전')
    // console.log(morpheme)
    // console.log(spellEle.key)
    // console.log(e)
    // setColor(colorList[e.target.value][0]);
    color = constituentColor[e.target.value][0];
    // console.log(color,'다뀌는 중')
    // console.log(e.target.value)
    changeMorpheme(
      spellEle.key,
      morpheme,
      e.target.value,
      spellIndex,
      rowIdx
    ); // 0번은 컬러넘버
      setSelecting(false)
    // console.log(color,'다뀐 후')
    // console.log(spellIndex)
  };

  // useEffect(()=>{
  //   setColor(colorList[morpheme][0])
  // },[])

  return (
    <StyledMorpheme style={{ background: color }}>
      {children}
      {/* {console.log('여기')} */}
      <pre style={{cursor:"pointer", margin:"0px",border: selecting ? "red 1px solid" : "none"}} onClick={()=>{setSelecting(!selecting)}}>{spellEle.value}</pre>
      {selecting ?
      <StyledSelect value={morpheme} onChange={(e) => morphemeHandler(e)}>
        <option value={0}>미정</option>
        <option value="sentence_subject">주어</option>
        <option value="sentence_verb">동사</option>
        <option value="sentence_complement">보어</option>
        <option value="sentence_direct_object">직목</option>
        <option value="sentence_indirect_object">간목</option>
        <option value="sentence_adverb">부사</option>
        <option value="sentence_etc">기타</option>
      </StyledSelect> : null}
    </StyledMorpheme>
  );
}

export default ExcelMorpheme;
